import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../../common/widgets/Button';
import Dialog from '../../../../../common/widgets/Dialog';
import { rewriteImageUrl } from '../../../helpers';
import { ContestModel } from '../../../models/Contest';
import { resources } from '../../../resources/resources';

export const ContestHomeDialog = ({
  contest,
  onCloseDialog,
}: {
  contest: ContestModel;
  onCloseDialog: () => void;
}) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const onButtonClick = () => {
    navigate(`/contests/${contest.contestId}`);
    onCloseDialog();
  };
  return (
    <Dialog
      closeDialog={onCloseDialog}
      showCloseIcon
      className="dialog-contest"
    >
      <div className="dialog-content">
        <div className="dialog-image">
          <img src={rewriteImageUrl(contest.dialogImage)} alt={contest.title} />
        </div>
        <div className="dialog-title">{contest.title}</div>
        <div
          dangerouslySetInnerHTML={{ __html: contest.shortDescription ?? '' }}
          className="dialog-text centered"
        />
      </div>
      <div className="dialog-actions vertical">
        <Button onClick={onButtonClick} className="btn btn-solid">
          {contest.callToAction || translate(resources.contests.registerNow)}
        </Button>
      </div>
    </Dialog>
  );
};
